import { Injectable } from '@angular/core';
import { RequestProviderService } from '@shared/services/http/http-provider.service';
import { HttpHeaders, HttpParams } from '@angular/common/http';
@Injectable({
  providedIn: 'root'
})
export class ServiceRequestService {

  constructor(
    private httpProvider: RequestProviderService
  ) { }


  public sendCbmDetailsView(id: string, city: string) 
  {
    return this.httpProvider.sendGetCustRequest(`/contractor/details?id=${id}&top_city=${city}`, new HttpHeaders, new HttpParams)
  }

  public getRecommendedCBMS(body : any)
  {
    
    return this.httpProvider.sendPostRequest('/contractor/recommended', body, new HttpHeaders, new HttpParams)
  
  }

  public getCityList()
  {
    return this.httpProvider.sendGetRequest('/city-list', new HttpHeaders, new HttpParams)
  }

  public getContractorDetails(id: any, top_city: any)
  {
    return this.httpProvider.sendGetRequest(`/contractor/details?id=${id}&top_city=${top_city}`, new HttpHeaders, new HttpParams)
  }

  public getCxeStatus(id:any)
  {
    return this.httpProvider.sendGetRequest(`/cxe/status/${id}`, new HttpHeaders, new HttpParams)
  }

  public getContractorList(body: any) {
    return this.httpProvider.sendPostRequest('/contractor/list', body, new HttpHeaders, new HttpParams)
  }

  public getServiceTypes() {
    return this.httpProvider.sendGetRequest('/service-types', new HttpHeaders, new HttpParams)
  }

  public getBundles(body: any) {
    return this.httpProvider.sendPostRequest('/service-bundles', body, new HttpHeaders, new HttpParams)
  }

  public getBundlesNew() {
    return this.httpProvider.sendGetRequest('/service-bundles', new HttpHeaders, new HttpParams)
  }

  public getRate(body: any) {
    return this.httpProvider.sendPostRequest('/service-rate', body, new HttpHeaders, new HttpParams)
  }

  public getRecommendedCBM(body: any) {
    return this.httpProvider.sendPostRequest('/recommended-cbm', body, new HttpHeaders, new HttpParams)
  }

  public getCBMList(body: any) {
    return this.httpProvider.sendPostRequest('/cbm-list', body, new HttpHeaders, new HttpParams)
  }

  public getFrontlinerOfficeId(officeName: string) {
    return this.httpProvider.sendGetRequest(`/f/offices?name=` + `${officeName}`, new HttpHeaders, new HttpParams)
  }

  public createRequest(body: any) {
    return this.httpProvider.sendPostRequest('/create', body, new HttpHeaders, new HttpParams)
  }

  public createRequestF(id: string, body: any)
  {
    return this.httpProvider.sendPostRequest(`/f/create/${id}`, body, new HttpHeaders, new HttpParams)
    
  }

  public getServiceRequests(body: any, skipCount: any, userType: string, ordering: string, categorySort: string, filterBy: string, filterStatus: string, filterBC: string, forExport: boolean = false) {

   const closedCancelled = userType === 'SystemAdministrator' ? 'true' : '' ;

    const reqBody = {...body, 'skipCount': skipCount.toString() };
  
    return this.httpProvider.sendPostRequest(`/f/search_v2?` 
                          + `filter_by=${filterBy}` 
                          + `&filter_with=${filterStatus}` 
                          + `&sort_by=${categorySort}`
                          + `&order_by=${ordering}` 
                          + `&closed_cancelled=${closedCancelled}`
                          + `&filter_bc=${filterBC}`
                          + `${forExport ? '&limit=all' : ''}`, reqBody , new HttpHeaders, new HttpParams())
  
  }

  public getRequest(id:any){
    return this.httpProvider.sendGetRequest(`/f/${id}`, new HttpHeaders, new HttpParams);
  }

  public updateServiceRequestStatus(id:any ,body:any) {
    return this.httpProvider.sendPatchRequest(`/f/updatestatus/${id}`, body, new HttpHeaders, new HttpParams)
  }

  public updateServiceRequestBundle(id:any, body:any) {
    return this.httpProvider.sendPatchRequest(`/f/bundleModify/${id}`, body, new HttpHeaders, new HttpParams)
  }

  public updateServiceRequestToRework(contId: any, body: any) {
    
    return this.httpProvider.sendPostRequest(`/f/rework-service-request/${contId}`, body, new HttpHeaders, new HttpParams)
  }

  public updateServiceRequestInfo(id: any, body: any) {
    return this.httpProvider.sendPatchRequest(`/f/updateactor/${id}`, body, new HttpHeaders, new HttpParams)
  }

  public updateServiceRequest(id:any ,body:any) {
    return this.httpProvider.sendPatchRequest(`/f/update/${id}`, body, new HttpHeaders, new HttpParams)
  }

  public acceptCancelServiceRequest(id:string , refNum: string, contractorID:string, userEmail:string , bundleName:string, reassign:boolean, cancelReason?:string, cancelRemarks?:string) {
    
    let  body = {
      "reassign": reassign,
      "serviceInformation": {
        "pendingCancellationReason": cancelReason,
        "pendingCancellationRemarks": cancelRemarks
      },
      "user": {
        "contractorID": contractorID,
        "emailAddress": userEmail
      },
      "sr_id": id
    }

    /*if(reassign == true)
    {
      body = {
        "actor": "frontliner",
        "actorName":localStorage.getItem('userScreenName'),
        "serviceInformation":{
          "status": "For CBM Acceptance"//"Pending Cancellation"
        },
        "user": {
          "contractorID": contractorID,
          "emailAddress": userEmail
        },
        "bundleName": bundleName,
        "reassign": reassign
      }
    }
    else if(reassign == false)
    {
      body = {
        "actor": "frontliner",
        "actorName":localStorage.getItem('userScreenName'),
        "serviceInformation":{
          "status": "Cancelled"
        },
        "user": {
          "contractorID": contractorID,
          "emailAddress": userEmail
        },
        "bundleName": bundleName,
        "reassign": reassign
      }
    }*/


    /*if(cancelReason && cancelRemarks){
      body['serviceInformation']['cancelReason'] = cancelReason
      body['serviceInformation']['cancelRemarks'] = cancelRemarks
    }*/
    console.log(body)
    return this.httpProvider.sendPatchRequest(`/f/acceptcancel/${refNum}`, body, new HttpHeaders, new HttpParams)
  }

  public rejectCancelServiceRequest(id:string , refNum: string, userEmail:string, contractorID : string) {
    /*let body = {
                "actor": "frontliner",
                "serviceInformation":{
                  "status": 'Cancelled'
                },
                "user": {
                  "emailAddress": userEmail
                }

    }*/
    let body = {
      "user": {
          "contractorID": contractorID,
          "emailAddress": userEmail
      },
      "sr_id": id
  }
    return this.httpProvider.sendPatchRequest(`/f/rejectcancel/${refNum}`, body, new HttpHeaders, new HttpParams)
  }
  

  public getServiceRequestActivities(id: any) {
    return this.httpProvider.sendGetRequest(`/activity/${id}`, new HttpHeaders, new HttpParams)
  }

  public getTransHistory(id: any,
                                       query: string = '',
                                       offset: number,
                                       order: string = '',
                                       sort: string = '',
                                       filter: string = '',
                                       filter_with: string = '',
                                       forExport: boolean = false) {
    const body = { frontliner_id : id};

    return this.httpProvider
               .sendPostRequest(`/f/service-request/history?` +
                                      `keyword=${query}` +
                                      `&skip_count=${offset}` +
                                      `&order_by=${order}` +
                                      `&sort_by=${sort}` +
                                      `&filter_by=${filter}` +
                                      `&filter_with=${filter_with}` +
                                       `${forExport ? '&limit=all' : ''}`,
                                    body,
                                    new HttpHeaders,
                                    new HttpParams);
  }

  public validatePassword(body: any) {
    return this.httpProvider.sendPostRequest(`/password/validate`, body, new HttpHeaders, new HttpParams)
  }

  public saveNewPassword(body: any)
  {
    return this.httpProvider.sendPostRequest(`/password/change`, body, new HttpHeaders, new HttpParams)
  }

  public getAccountInformation(email: string)
  {
    return this.httpProvider.sendGetRequest(`/user/?email=${email}`, new HttpHeaders, new HttpParams)
  }

  // public getServiceRequestsPagination(body: any, currentPage: number) {
  //   let itemsCount = currentPage * 50
  //   let skipCount = (Math.ceil(itemsCount/100) * 100)
  //   return this.httpProvider.sendPostRequest('/f/search/p', {...body, "skipCount": skipCount.toString()}, new HttpHeaders, new HttpParams())
  // }

  public generateFrontlinerReport(id: any, reportType: any, body: any) {
    if (body.dateRangeFrom === '' && body.dateRangeTo === '') {
      return this.httpProvider.sendGetRequest(
        `/report?report_type=${reportType}&frontliner_id=${id}`,
        new HttpHeaders(),
        new HttpParams()
      );
    }

    return this.httpProvider.sendGetRequest(
      `/report?report_type=${reportType}&frontliner_id=${id}&start_date=${body.dateRangeFrom}&end_date=${body.dateRangeTo}`,
      new HttpHeaders(),
      new HttpParams()
    );
  }

 public monitorReworkRate()
 {
   let body = {
     'body': ""
   }
   return this.httpProvider.sendPostRequest(`/update-contractor-rework/call`, body,new HttpHeaders, new HttpParams)
 }

 public storeLoginToken(email : string, token: string, loginConfirmation: string)
 {
   let body = {
     'email': email,
     'token': token,
     'isLoggedIn': loginConfirmation
   }

   return this.httpProvider.sendPostRequest(`/session-token/store`, body, new HttpHeaders, new HttpParams)
 
 }

 public getLoginToken(newToken : string, email: string)
  {
    let body = {
      'token': newToken
    }

    return this.httpProvider.sendPostRequest(`/session-token?email=${email}`, body, new HttpHeaders, new HttpParams)
  }

  public domainBlackListAddList(listBlackListed  : any)
  {
    let body = listBlackListed

    return this.httpProvider.sendPostRequest(`/domain-blacklist/mass-add`, body, new HttpHeaders, new HttpParams)
  }

  public domainBlackListValidation(email : string)
  {
    let body = {
      "email": email
    }

    return this.httpProvider.sendPostRequest(`/domain-blacklist/validate`, body, new HttpHeaders, new HttpParams)
  
  }
}
